<template>
  <default>
    <div class="cust-pa-wrap">
      <pa-finalization-page :quote-id="quoteId" channel="customer" />
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import PaFinalizationPage from '@/components/pa/PaFinalizationPage';

export default {
  name: 'CustomerPaFinalization',
  components: { Default, PaFinalizationPage },
  props: ['quoteId'],
  metaInfo: { title: 'Students PA — Complete' },
};
</script>

<style src="@/assets/css/customer-pa.css"></style>
